import { useEffect, useState } from 'react';
import {
  DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton,
  GridToolbarDensitySelector, GridToolbarExportContainer, GridCsvExportMenuItem, esES,
  GridPrintExportMenuItem, gridClasses } from '@mui/x-data-grid';
import jwt_decode from "jwt-decode";
import { Breadcrumbs, Card, CardContent, CardHeader, Grid, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import dayjs from "dayjs";
import 'dayjs/locale/es-mx.js'
import { useLocation } from 'react-router-dom';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

dayjs.locale('es-mx')

const csvOptions = { utf8WithBom: true };
const printOptions = {
  hideFooter: true,
  hideToolbar: true,
}

const CustomExportButton = (props) => (
  <GridToolbarExportContainer {...props}>
    <GridCsvExportMenuItem options={csvOptions} />
    <GridPrintExportMenuItem options={printOptions} />
  </GridToolbarExportContainer>
);

const CustomToolbar = (props) => (
  <GridToolbarContainer {...props}>
    <GridToolbarColumnsButton />
    <GridToolbarFilterButton />
    <GridToolbarDensitySelector />
    <CustomExportButton />
  </GridToolbarContainer>
);

export default function Tramites() {
  const navigate = useNavigate()
  const location = useLocation();
  const { nombreArchivo, fecha, anio } = location.state || {};
  const [data, setData] = useState({ columns: [], rows: [] })
  const [pageSize, setPageSize] = useState(15)
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    fecha: false,
  });


  // Operador de filtro personalizado
  /*const dateRangeOperator = {
    label: 'entre',
    value: 'dateRange',
    getApplyFilterFn: (filterItem) => {

      if (!filterItem.value || !filterItem.value[0] || !filterItem.value[1]) {
        return null;
      }
      return ({ value }) => {
        
        const cellDate = value;
        const startDate = filterItem.value[0]
        const endDate = filterItem.value[1]

       
        return dayjs(cellDate).format('YYYY/MM/DD') >= dayjs(startDate).format('YYYY/MM/DD') && dayjs(cellDate).format('YYYY/MM/DD') <= dayjs(endDate).format('YYYY/MM/DD');
      };
    },
    InputComponent: ({ item, applyValue }) => (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Box display="flex" gap={1}>
          <TextField
            label="Fecha inicio"
            type="date"
            value={startDate}
            //onChange={handleDateChange}
            onChange={(event) => {
              const date = event.target.value
              setStartDate(date);
              console.log(JSON.stringify(item))
              applyValue({ ...item, value: [date, item.value ? item.value[1] : null] });

            }}
            InputLabelProps={{
              shrink: true, // Para que la etiqueta no cubra la fecha seleccionada
            }}
            variant="standard"
          />
          <TextField
            label="Fecha fin"
            type="date"
            value={endDate}
            onChange={(event) => {
              const date = event.target.value
              setEndDate(date);
              //applyValue({ ...item, value: date });
              applyValue({ ...item, value: [item.value ? item.value[0] : null, date] });

            }}
            InputLabelProps={{
              shrink: true, // Para que la etiqueta no cubra la fecha seleccionada
            }}
            variant="standard"
          />
        </Box>
      </LocalizationProvider>
    ),
  };*/

  const token = sessionStorage.getItem('token')
  const decoded = jwt_decode(token);
  const obtenerReglas = () => {
    let reglas
    const perfilElegido = sessionStorage.getItem('perfilElegido')
    switch (perfilElegido) {
      case 'asistente':
        reglas = decoded.rulesAsistente
        break
      case 'investigador':
        reglas = decoded.rulesJefaturaArea
        break
      case 'coordinacion':
        reglas = decoded.rulesCoordinacion
        break
      case 'jefe':
        reglas = decoded.rulesJefatura
        break
      case 'administracion':
        reglas = decoded.rulesAdministracionProyecto
        break
      default:
        break
    }
    return reglas
  }

  let reglas = decoded.rules

  if (!reglas)
    reglas = obtenerReglas()

  useEffect(() => {
    (async () => {
      const resSaldos = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/reporteTramites/importarExcel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": sessionStorage.getItem('token'),
          "perfil": sessionStorage.getItem('perfil'),
          "identidad": sessionStorage.getItem('idEntidad'),
          "identidadsuperior": sessionStorage.getItem('idEntidadSuperior')
        },
        body: JSON.stringify({
          "file": nombreArchivo,
          "anio": anio
        })
      })

      const respuesta = await resSaldos.json()
      
      const datos = {
        columns: [
          {
            field: "Documento", headerName: "Documento", width: 120, hide: false, sortable: true, filterable: true, hideable: true
          },

          {
            field: "Proyecto", headerName: "Proyecto", width: 300, sortable: true, filterable: true, type: "string",
            hideable: true,
            valueGetter: (params) => {
              // Buscar una sola vez el proyecto que coincide con params.value
              const proyecto = respuesta.proyectos.find(proyecto =>
                String(proyecto.clave.trim()).localeCompare(String(params.value.trim())) === 0
              );

              // Si se encuentra el proyecto, construimos el valor adecuado
              if (proyecto) {
                return `${params.value} - ${proyecto.descripcion} \n${proyecto.responsable}`;
              } else {
                return params.value; // Si no se encuentra el proyecto, solo devolvemos el valor
              }
            }
          },
          {
            field: "Partida", headerName: "Partida", width: 200, sortable: true, filterable: true, type: "string",
            hideable: true,
            valueGetter: (params) => {
              // Buscar una sola vez el proyecto que coincide con params.value
              const partida = respuesta.partidas.find(partida =>
                String(partida.clave.trim()).localeCompare(String(params.value.trim())) === 0
              );

              // Si se encuentra el proyecto, construimos el valor adecuado
              if (partida) {
                return `${params.value} - ${partida.concepto}`;
              } else {
                return params.value; // Si no se encuentra el proyecto, solo devolvemos el valor
              }
            }
          },
          {
            field: "ImporteCompromiso", headerName: "ImporteCompromiso", sortable: true, filterable: true, type: "number",
            hideable: true,
            valueFormatter: (params) => {
              return Number(params.value).toLocaleString("es-MX", { style: "currency", currency: "MXN" });
            }
          },
          {
            field: "TipoDoc", headerName: "Tipo Doc.", sortable: true, filterable: true,
            hideable: true
          },
          {
            field: "EdoCompromiso", headerName: "Edo. Compromiso", sortable: true, filterable: true, type: "number",
            hideable: true
          },
          {
            field: "DescEdo", headerName: "Desc. Edo.", width: 150, sortable: true, filterable: true,
            hideable: true
          },
          {
            field: "ElaboraCompromiso", headerName: "Elabora Compromiso", sortable: true, filterable: true, type: "date",
            hideable: true,
            valueFormatter: ({ value }) => `${dayjs.utc(value).format('DD/MMM/YYYY')}`
          },
          {
            field: "Solicitud", headerName: "Solicitud", width: 150, sortable: true, filterable: true,
            hideable: true
          },
          {
            field: "NumTram", headerName: "Num. Tram.", sortable: true, filterable: true, type: "number",
            hideable: true
          },
          {
            field: "DescripcionTram", headerName: "Descripción Tram.", width: 200, sortable: true, filterable: true,
            hideable: true
          },
          {
            field: "EstadoST", headerName: "Estado ST", sortable: true, filterable: true, type: "number",
            hideable: true
          },
          {
            field: "DescripcionEdoST", headerName: "Descripción Edo. ST", width: 120, sortable: true, filterable: true,
            hideable: true
          },
          {
            field: "DescripcionST", headerName: "Descripción ST", width: 400, sortable: true, filterable: true,
            hideable: true
          },
          {
            field: "ElaboraST", headerName: "Elabora ST", sortable: true, filterable: true, type: "date",
            hideable: true,
            valueFormatter: ({ value }) => `${dayjs.utc(value).format('DD/MMM/YYYY')}`
          },
          {
            field: "ImporteST", headerName: "Importe ST", sortable: true, filterable: true, type: "number",
            hideable: true,
            valueFormatter: (params) => {
              return Number(params.value).toLocaleString("es-MX", { style: "currency", currency: "MXN" });
            }
          },
        ],

        rows: respuesta.registros.map((registro, index) => ({
          id: index,
          ...registro
        }))
      }


      setData(datos)




    })();
    // eslint-disable-next-line
  }, [/*solicitud, ocultarContratos*/]
  )

  /*useEffect(() => {
    if(filterModel.items && filterModel.items[0] && filterModel.items[0].value  && filterModel.items[0].operatorValue==='dateRange' ){
      setStartDate (dayjs(filterModel.items[0].value[0]))
      setEndDate(dayjs(filterModel.items[0].value[1]));
    }
  }, [filterModel]);*/

  return (
    <><div role="presentation" style={{ marginTop: '20px' }} >
      <Breadcrumbs aria-label="breadcrumb">
        <Link
          underline="hover"
          sx={{ display: 'flex', alignItems: 'center' }}
          color="inherit"
          href="javascript:void(0)" onClick={() => { navigate(-1) }}
        >
          <KeyboardReturnIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Regresar
        </Link>
      </Breadcrumbs>
    </div>
      <div style={{ display: 'flex', marginTop: '50px' }}>
        <Grid container rowSpacing={2} columnSpacing={5}>
          <Grid item xs={12} md={12}>
            <Card style={{ height: '100%', width: '100%' }}>
              <CardHeader title={`Trámites al ${fecha}`}></CardHeader>
              <CardContent sx={{ height: 700 }}>
                <DataGrid {...data} pageSize={pageSize} getRowHeight={() => 'auto'} getRowId={(row) => row.id} sx={{
                  [`& .${gridClasses.cell}`]: {
                    py: 1,
                  },
                  '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                  '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                  '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
                }}
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)} rowsPerPageOptions={[5, 10, 15]} localeText={esES.components.MuiDataGrid.defaultProps.localeText} components={{ Toolbar: CustomToolbar }}
                  /*filterModel={filterModelRef.current}
                  onFilterModelChange={(newFilterModel) => {
                    filterModelRef.current = newFilterModel;
                    setFilterModel(newFilterModel);
                  }}*/                 
                  columnVisibilityModel={columnVisibilityModel}
                  onColumnVisibilityModelChange={(newModel) => {
                    // Forzar la columna 'fecha' a permanecer oculta
                    setColumnVisibilityModel((prevModel) => ({
                      ...newModel,
                      fecha: false,
                    }));
                  }}
                >
                </DataGrid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    </>
  );
}